import React from "react"
import Slider from "react-slick"
import Img from "gatsby-image"
import PropTypes from "prop-types"
import Styles from "./Carousel.module.scss"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./CarouselOverride.scss"

// takes and Array of Images

const Carousel = props => {
  const { images } = props

  //   Custom Buttons
  const ArrowLeft = ({ currentSlide, slideCount, children, ...props }) => (
    <button {...props} className={Styles.prev}>
      <svg
        width="30px"
        height="30px"
        viewBox="0 0 54 100"
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="left"
          transform="matrix(-1 8.742278E-08 -8.742278E-08 -1 53.07692 99.14532)"
        >
          <path
            d="M5.98291 98.1197C5.29915 98.8034 4.44444 99.1453 3.50427 99.1453C2.5641 99.1453 1.7094 98.8034 1.02564 98.1197C-0.34188 96.7521 -0.34188 94.5299 1.02564 93.1624L44.6154 49.5727L1.02564 5.98291C-0.34188 4.61539 -0.34188 2.39316 1.02564 1.02564C2.39316 -0.34188 4.61538 -0.34188 5.98291 1.02564L52.0513 47.094C53.4188 48.4615 53.4188 50.6838 52.0513 52.0513L5.98291 98.1197Z"
            id="Path"
            fill="#ffffff"
            stroke="none"
          />
        </g>
      </svg>
    </button>
  )
  const ArrowRight = ({ currentSlide, slideCount, children, ...props }) => (
    <button {...props} className={Styles.next}>
      <svg
        width="30px"
        height="30px"
        viewBox="0 0 54 100"
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="right">
          <path
            d="M5.98291 98.1197C5.29915 98.8034 4.44444 99.1453 3.50427 99.1453C2.5641 99.1453 1.7094 98.8034 1.02564 98.1197C-0.34188 96.7521 -0.34188 94.5299 1.02564 93.1624L44.6154 49.5727L1.02564 5.98291C-0.34188 4.61538 -0.34188 2.39316 1.02564 1.02564C2.39316 -0.34188 4.61538 -0.34188 5.98291 1.02564L52.0513 47.094C53.4188 48.4615 53.4188 50.6838 52.0513 52.0513L5.98291 98.1197Z"
            transform="translate(0.3418804 0.4273504)"
            id="Path"
            fill="#ffffff"
            stroke="none"
          />
        </g>
      </svg>
    </button>
  )

  const settings = {
    // centerMode: true,
    dots: true,
    infinite: true,
    prevArrow: <ArrowLeft />,
    nextArrow: <ArrowRight />,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false,
        },
      },
    ],
  }

  return (
    <Slider className={Styles.slidercustom} {...settings}>
      {images.map(image => {
        return (
          <Img
            className={Styles.gatsbyimageoverride}
            key={image.id}
            fluid={image.fluid}
            alt={image.description}
          />
        )
      })}
    </Slider>
  )
}

Carousel.propTypes = {
  images: PropTypes.array,
}

  Carousel.defaultProps = {
    image: `[]`,
  }

export default Carousel
